import { useContext, useEffect, useState } from 'react'
import AppTable from '../table/AppTable';
import { useLazyQuery } from '@apollo/client';
import { GET_LIST_TICKETS, GET_LIST_TICKETS_BY_LOGITIXUSER } from '../../../features/Tickets/api/TicketsQuery';
import { globalContext } from '../../../Provider/AppProvider';
import { CircularProgress } from '@mui/material';
import ToasterWithMessage from '../toaster';
import styles from '../../../features/Users/Users.module.css'
import { roles } from '../../../helper';

const ListTickets = (props: any) => {
  const {
    rowsPerPage,
  currentPage,
  setCurrentPage, 
  checking,
  setChecking, 
  listTicketList,
  setListTicketList,
  selected,
  setSelected,
  columnTypes,
  setColumnTypes,
  sortType,
  setSortType,
  GenerateListTicketHeadCells,
  handleChangeRowsPerPage,
  handlePageChange,
  activeTab,
  setSelectedTickets,
  selectedTickets
  } = props;

  const {globalState,handleGlobalState} = useContext<any>(globalContext);
  const [searchvalue, setSearchvalue] = useState(globalState?.globalSearch?.searchtext);
  const {error} = ToasterWithMessage();

  const [getListTickets, {loading}] = useLazyQuery(GET_LIST_TICKETS,{
    fetchPolicy: 'no-cache',
    onCompleted: (listTicketData) => {
        setListTicketList(listTicketData);
        const tempState = {...globalState};
        tempState.listTicketFilter.clicked = false;
        if(globalState.notification.notificationClicked){
        tempState.manageTicketFilter.notificationFilterDataCount = listTicketData?.filtermanagetickets_aggregate?.aggregate?.count;
        tempState.listTicketFilter.notificationFilterDataCount = listTicketData?.filterlisttickets_aggregate?.aggregate?.count;
        tempState.soldTicketFilter.notificationFilterDataCount = listTicketData?.FilterSoldTickets_aggregate?.aggregate?.count;
        tempState.delistAndReturnTicketFilter.notificationFilterDataCount = listTicketData?.filterreturntickets_aggregate?.aggregate?.count;
        tempState.unsoldTicketFilter.notificationFilterDataCount = listTicketData?.filterUnsoldTickets_aggreagate?.aggregate?.count;
      }if(globalState.error.errorClicked){  
        tempState.manageTicketFilter.errorFilterDataCount = listTicketData?.filtermanagetickets_aggregate?.aggregate?.count;
        tempState.listTicketFilter.errorFilterDataCount = listTicketData?.filterlisttickets_aggregate?.aggregate?.count;
        tempState.soldTicketFilter.errorFilterDataCount =listTicketData?.FilterSoldTickets_aggregate?.aggregate?.count;  
        tempState.delistAndReturnTicketFilter.errorFilterDataCount = listTicketData?.filterreturntickets_aggregate?.aggregate?.count;
        tempState.unsoldTicketFilter.errorFilterDataCount = listTicketData?.filterUnsoldTickets_aggreagate?.aggregate?.count;
        tempState.listTicketFilter.clicked = false;
      }
        handleGlobalState(tempState);
    },
    onError: () => {
        error("We’re having trouble connecting. Please clear your cache, refresh the page, and try again.");
    }
  })
  const [getListTicketsByLogitix, {loading:logitixLoading}] = useLazyQuery(GET_LIST_TICKETS_BY_LOGITIXUSER,{
    fetchPolicy: 'no-cache',
    onCompleted: (listTicketDataForLogitix) => {
        setListTicketList(listTicketDataForLogitix);
        const tempState = {...globalState};
        tempState.listTicketFilter.clicked = false;
        if(globalState.notification.notificationClicked){
        tempState.manageTicketFilter.notificationFilterDataCount = listTicketDataForLogitix?.filtermanagetickets_aggregate?.aggregate?.count;
        tempState.listTicketFilter.notificationFilterDataCount = listTicketDataForLogitix?.filterlisttickets_aggregate?.aggregate?.count;
        tempState.soldTicketFilter.notificationFilterDataCount = listTicketDataForLogitix?.FilterSoldTickets_aggregate?.aggregate?.count;
        tempState.delistAndReturnTicketFilter.notificationFilterDataCount = listTicketDataForLogitix?.filterreturntickets_aggregate?.aggregate?.count;
        tempState.unsoldTicketFilter.notificationFilterDataCount = listTicketDataForLogitix?.filterUnsoldTickets_aggreagate?.aggregate?.count;
      }if(globalState.error.errorClicked){  
        tempState.manageTicketFilter.errorFilterDataCount = listTicketDataForLogitix?.filtermanagetickets_aggregate?.aggregate?.count;
        tempState.listTicketFilter.errorFilterDataCount = listTicketDataForLogitix?.filterlisttickets_aggregate?.aggregate?.count;
        tempState.soldTicketFilter.errorFilterDataCount =listTicketDataForLogitix?.FilterSoldTickets_aggregate?.aggregate?.count;  
        tempState.delistAndReturnTicketFilter.errorFilterDataCount =listTicketDataForLogitix?.filterreturntickets_aggregate?.aggregate?.count;  
        tempState.unsoldTicketFilter.errorFilterDataCount =listTicketDataForLogitix?.filterUnsoldTickets_aggreagate?.aggregate?.count;  
        tempState.listTicketFilter.clicked = false;
      }
        handleGlobalState(tempState);
    },
    onError: () => {
        error("We’re having trouble connecting. Please clear your cache, refresh the page, and try again.");
    }
  })

  useEffect(() => {
    const tempdata = {...globalState}
    setSearchvalue(tempdata?.globalSearch?.searchtext)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [globalState?.globalSearch?.searchtext]);

  useEffect(() => {
    const listTicketsVariables={
      leagueId: globalState?.listTicketFilter?.leagueId,
      ticketStatus: globalState?.listTicketFilter?.ticketStatus,
       startdate:globalState?.listTicketFilter?.startdate ? globalState?.listTicketFilter?.startdate : globalState?.listTicketFilter?.startDateRange,
       enddate:globalState?.listTicketFilter?.enddate ? globalState?.listTicketFilter?.enddate : globalState?.listTicketFilter?.endDateRange,
       pageSize: rowsPerPage,
       pageOffset: (currentPage -1)*rowsPerPage,
       order_by: [{[columnTypes]: sortType},{"tp_id": "asc"}],
       search_event:searchvalue === globalState.notification.text ?"%":searchvalue === globalState.error.text ?"%":`${searchvalue}%`,
       ticketId:globalState.notification.ticketId,
       ticketPlacementId: globalState.notification.tpId,
       array_tpid: globalState?.notification.tp_id_array?globalState?.notification.tp_id_array:globalState?.error?.approximateTpArray?.length > 0  ? globalState.error.approximateTpArray : globalState.error.ticketPlacementId
      };

    if((globalState.profile.userRole===roles.ADMIN || globalState.profile.userRole===roles.AFFILIATER_ADMIN)){
    getListTickets({
      variables: listTicketsVariables
    })
  }else{
    getListTicketsByLogitix({
      variables: listTicketsVariables
    })
  }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [globalState?.globalSearch?.searchtext,searchvalue,globalState.notification.notificationSearchCancel]);

useEffect(()=>{
  if((activeTab === 1) || globalState?.markAsSoldTicket?.markAsSold === true || globalState?.ticketUpdate?.delistTicket === true|| globalState?.ticketUpdate?.listPrice === true || globalState?.ticketUpdate?.returnTicket === true || globalState?.ticketUpdate?.listTicket === true){
    const ticketsVariables= {
      leagueId:  globalState?.notification?.notificationClicked ? null: globalState?.error?.errorClicked? null : globalState?.listTicketFilter?.leagueId,
      ticketStatus:  globalState?.notification?.notificationClicked ? null: globalState?.error?.errorClicked ? null : globalState?.listTicketFilter?.ticketStatus,
       startdate:  globalState?.notification?.notificationClicked ? null:globalState?.error?.errorClicked? null : globalState?.listTicketFilter?.startdate ? globalState?.listTicketFilter?.startdate : globalState?.listTicketFilter?.startDateRange,
       enddate:  globalState?.notification?.notificationClicked ? null:globalState?.error?.errorClicked? null : globalState?.listTicketFilter?.enddate ? globalState?.listTicketFilter?.enddate : globalState?.listTicketFilter?.endDateRange,
       pageSize: rowsPerPage,
       pageOffset: (currentPage -1)*rowsPerPage,
       order_by: [{[columnTypes]: sortType}, {"tp_id": "asc"}],
       search_event:searchvalue === globalState.notification.text ?"%":searchvalue === globalState.error.text ?"%":`${searchvalue}%`,
       ticketId:globalState.notification.ticketId,
       ticketPlacementId: globalState.notification.tpId,
       array_tpid: globalState?.notification.tp_id_array?globalState?.notification.tp_id_array:globalState?.error?.approximateTpArray?.length > 0  ? globalState.error.approximateTpArray : globalState.error.ticketPlacementId
      };

    if((globalState.profile.userRole===roles.ADMIN || globalState.profile.userRole===roles.AFFILIATER_ADMIN)){
    getListTickets({
      variables:ticketsVariables
    })
  }else{
    getListTicketsByLogitix({
      variables: ticketsVariables
    })
  }
  }
  const tempState = {...globalState};
  tempState.markAsSoldTicket.markAsSold = false;
  tempState.ticketUpdate.delistTicket = false;
  tempState.ticketUpdate.listPrice = false;
  tempState.ticketUpdate.returnTicket = false;
  tempState.ticketUpdate.listTicket  = false;
  handleGlobalState(tempState)

// eslint-disable-next-line react-hooks/exhaustive-deps
},[activeTab,
  getListTickets,
  rowsPerPage,
  currentPage,
  sortType,
  columnTypes,
  searchvalue,
  globalState?.markAsSoldTicket?.markAsSold,
  globalState?.ticketUpdate?.delistTicket,
  globalState?.ticketUpdate?.listPrice,
  globalState?.ticketUpdate?.returnTicket,
  globalState?.ticketUpdate?.listTicket
]);

useEffect(()=>{
  if(globalState.listTicketFilter.clicked){
    const getListTicketsVariables={
      leagueId: globalState?.listTicketFilter?.leagueId,
      ticketStatus: globalState?.listTicketFilter?.ticketStatus,
       startdate:globalState?.listTicketFilter?.startdate ? globalState?.listTicketFilter?.startdate : globalState?.listTicketFilter?.startDateRange,
       enddate:globalState?.listTicketFilter?.enddate ? globalState?.listTicketFilter?.enddate : globalState?.listTicketFilter?.endDateRange,
       pageSize: rowsPerPage,
       pageOffset: (currentPage -1)*rowsPerPage,
       order_by: [{[columnTypes]: sortType},{"tp_id": "asc"}],
       search_event: `${searchvalue}%`,
       ticketId:globalState.notification.ticketId,
       ticketPlacementId: globalState.notification.tpId,
       array_tpid: globalState?.notification.tp_id_array?globalState?.notification.tp_id_array:globalState?.error?.approximateTpArray?.length > 0  ? globalState.error.approximateTpArray : globalState.error.ticketPlacementId
      };

    if((globalState.profile.userRole===roles.ADMIN || globalState.profile.userRole===roles.AFFILIATER_ADMIN)){
    getListTickets({
      variables: getListTicketsVariables
    });
  }else{
    getListTicketsByLogitix({
      variables: getListTicketsVariables
    });
  }
  }

// eslint-disable-next-line react-hooks/exhaustive-deps
},[
  getListTickets,
  globalState.listTicketFilter.clicked
]);
  return (
    <>
      {
        (loading || logitixLoading || globalState?.loadingFormarkassold?.soldloader)
      ?   <div className={styles.TableCircularProgress}>
          <CircularProgress color="primary" size={35} />
          </div>
      :
         <AppTable
           handleChangeRowsPerPage={handleChangeRowsPerPage}
           handlePageChange={handlePageChange}
           setColumnTypes = {setColumnTypes}
           sortType = {sortType}
           setSortType = {setSortType}
           setSelected = {setSelected}
           setChecking = {setChecking}
           checking = {checking}
           selected ={selected}
           rowsPerPage = {rowsPerPage}
           setCurrentPage={setCurrentPage}
           currentPage= {currentPage}
           list={listTicketList}
           tableTitle = "listtickets"
           generateHeadCells = {GenerateListTicketHeadCells}
           selectedTickets={selectedTickets}
           setSelectedTickets={setSelectedTickets}
         />
      }.
    </>
  );
}

export default ListTickets
